require('dropzone');

let dropPhoto;

Dropzone.autoDiscover = false;
initDropzone = function (url) {
    dropPhoto = new Dropzone('div#import', {
        url: url,
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        paramName: "file",
        maxFilesize: 1,
        acceptedFiles: ".xml",
        parallelUploads: 1,
        dictDefaultMessage: 'Arraste ou clique para selecionar os arquivos.',
        uploadprogress: function (file, progress, bytesSent) {
            $(file.previewElement).find('.dz-progress').text(progress + "%");
        },
        previewTemplate: '<div class="row">\n' +
        '<div class="col-lg-7"><span data-dz-name></span></div>\n' +
        '<div class="col-lg-1" data-dz-size></div>\n' +
        '<div class="col-lg-1"><span class="dz-progress"></span></div>\n' +
        '<div class="col-lg-3"><span class="dz-success-message"></span><span class="dz-error-message"></span></div>\n' +
        '</div>',
        init: function () {
            this.on('success', function (file, response) {
                $(file.previewElement).find('.dz-success-message').text(response.message);
            });
            this.on('error', function (file, response) {
                $(file.previewElement).find('.dz-error-message').text(response.message);
            });
        }
    });
};

if (typeof urlDropzone !== 'undefined') {
    initDropzone(urlDropzone);
}


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-dropzone.js